import React from "react";
import styled from "styled-components";
import { Markup } from "interweave";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { Close } from "../../../assets/svgs";
const TeamMemberExpanded = ({ teamMember, onDismiss }) => {
  return (
    <Container>
      <Image image={getImage(teamMember.image)} alt={teamMember.name} />
      <div>
        <h3>
          <Markup content={`${teamMember.name},<br /> ${teamMember.title}`} />
        </h3>
        <p>
          <Markup content={teamMember.bio} />
        </p>
      </div>
      <CloseButton onClick={onDismiss}>
        <Close />
      </CloseButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  justify-content: center;
  background-color: #f8f8f8;
  padding: 3rem 1.5rem;
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;
  max-width: 960px;
  position: relative;
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    span#special-character {
      font-size: 1.4rem;
    }
  }
  p {
    font-size: 1rem;
    span#special-character {
      font-size: 0.9rem;
    }
  }
  @media (min-width: 768px) {
    padding: 2.5rem;
    display: grid;
    gap: 2.5rem;
    grid-template-columns: 300px auto;
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  height: 330px;
  box-shadow: 0px 12px 30px rgba(217, 217, 217, 0.7);
  border-radius: 4px;
  @media (min-width: 500px) {
    width: 300px;
  }
`;

const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  height: 12px;
  width: 12px;
  z-index: 10;
  svg {
    height: 100%;
    width: auto;
  }
`;

export default TeamMemberExpanded;
